module.exports = __webpack_public_path__ + "img/circle-h.c430e6d9.svg";